// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Gg1d","inner":"Form_inner__1U84r","range":"Form_range__3KriI","name":"Form_name__3K2W3","actions":"Form_actions__1oFWR"};